module.exports = __webpack_public_path__ + "static/Intellect_Devourer-3817678ec36d91b9631ad1a1a937cd27.jpg";